import * as React from 'react';

const Persons = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={19} height={15} {...props}>
        <defs>
            <filter id="persons_a" width="104.3%" height="106.9%" x="-2.1%" y="-2.8%" filterUnits="objectBoundingBox">
                <feOffset dy={8} in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation={12} />
                <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
            </filter>
            <rect id="persons_b" width={1872} height={1152} x={24} y={24} rx={8} />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g transform="translate(-442 -309)">
                <use xlinkHref="#persons_b" fill="currentColor" filter="url(#persons_a)" />
                <rect
                    width={1871}
                    height={1151}
                    x={24.5}
                    y={24.5}
                    fill="#FFF"
                    stroke="#EBEBEB"
                    strokeLinejoin="miter"
                    rx={8}
                />
            </g>
            <g transform="translate(-14 -16)">
                <rect width={383} height={47} x={0.5} y={0.5} fill="#FFF" stroke="#EBEBEB" rx={4} />
                <g
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.25}
                    transform="translate(15 17)"
                >
                    <circle cx={5.526} cy={3.592} r={3.039} />
                    <path d="M.553 12.71a4.974 4.974 0 1 1 9.947 0" />
                    <circle cx={13.062} cy={5.25} r={2.487} />
                    <path d="M11.652 8.892a4.072 4.072 0 0 1 5.48 3.819" />
                </g>
            </g>
        </g>
    </svg>
);
export default Persons;
